<template>
  <div>
    <operation-report-show-body-header-presentational
      :title="serviceName"
      :subTitle="vesselName"
      :updatedAt="updatedAt"
    >
      <template v-slot:action-area>
        <operation-report-show-body-header-action-buttons
          v-show="isShowActionButtons"
          :privilege="privilege"
          @download="onReportDownload"
          @edit="onEdit"
          @delete="onDelete"
        />
      </template>
    </operation-report-show-body-header-presentational>

    <report-delete-dialog
      :active="isDeleteDialogActive"
      @accept="onDeleteAccept"
      @cancel="onDeleteCancel"
      class="operation-report-delete-dialog"
    />

    <report-download-dialog
      :active="isReportDownloadDialogActive"
      :csvList="aoEnterpriseCsvs"
      :vesselName="vesselName"
      @close="onReportDownloadDialogClose"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("operationReport");
import isObject from "lodash/isObject";
import {
  formatDateTime,
  notifyDeleteSuccess,
  notifyDeleteFailed,
  pushReportList,
  pushEditScreen,
  isEditingReport,
} from "@/utils/operations";
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

import OperationReportShowBodyHeaderPresentational from "./Header";
import OperationReportShowBodyHeaderActionButtons from "./ActionButtons";
import ReportDeleteDialog from "@/views/enterprise/addon/operation/components/dialogs/ReportDeleteDialog.vue";
import ReportDownloadDialog from "./ReportDownloadDialog.vue";

export default {
  name: "OperationReportShowBodyHeader",
  components: {
    OperationReportShowBodyHeaderPresentational,
    OperationReportShowBodyHeaderActionButtons,
    ReportDeleteDialog,
    ReportDownloadDialog,
  },
  props: {
    aoEnterpriseCsvs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isDeleteDialogActive: false, // 削除ダイアログ表示フラグ
      isReportDownloadDialogActive: false, // レポートダウンロードダイアログ表示フラグ
    };
  },

  computed: {
    ...mapGetters({
      reportOperationService: "reportOperationService",
      reportEnterpriseVessel: "reportEnterpriseVessel",
      reportUpdatedAt: "reportUpdatedAt",
      canEdit: "isReportUpdatable",
      canDelete: "isReportDeletable",
      currentWorkflowStatus: "reportWorkflowStatus",
    }),
    serviceName() {
      return this.reportOperationService;
    },
    vesselName() {
      const { vessel: v } = this.reportEnterpriseVessel;
      if (!isObject(v)) return "";
      return v.name_ja || v.name || "";
    },
    updatedAt() {
      if (!this.reportUpdatedAt) return "";
      return formatDateTime(this.reportUpdatedAt);
    },
    privilege() {
      return {
        canDownload:
          Array.isArray(this.aoEnterpriseCsvs) &&
          this.aoEnterpriseCsvs.length > 0,
        // 全てのレポートでダウンロード可能にする
        // && this.currentWorkflowStatus.is_complete === true
        canEdit: this.canEdit,
        canDelete: this.canDelete,
      };
    },
    promptColor() {
      return AISEA_COLOR.BLUE; // string
    },
    isShowActionButtons() {
      return !this.isEditingReport; // 編集中は表示しない
    },
    isEditingReport() {
      return isEditingReport(this);
    },
  },

  methods: {
    ...mapActions({
      deleteCurrentOperationReport: "deleteCurrentOperationReport",
    }),
    onEdit() {
      pushEditScreen(this, this.$route.params);
    },

    // 削除ボタン押下時のハンドリング
    onDelete() {
      this.showDeleteDialog();
    },
    // 削除ダイアログでacceptボタン押下時のハンドリング
    async onDeleteAccept() {
      await this.tryDeleteOperationReport();
      setTimeout(() => {
        this.isDeleteDialogActive = false;
      }, 0);
    },
    // 削除ダイアログでcancelボタン押下時のハンドリング
    onDeleteCancel() {
      setTimeout(() => {
        this.isDeleteDialogActive = false;
      }, 0);
    },
    showDeleteDialog() {
      this.isDeleteDialogActive = true;
    },
    closeDeleteDialog() {
      this.isDeleteDialogActive = false;
    },
    async tryDeleteOperationReport() {
      try {
        this.$vs.loading({ color: AISEA_COLOR.BLUE });
        const result = await this.deleteCurrentOperationReport();
        if (!result.status) {
          throw new Error(result.message);
        }
        notifyDeleteSuccess(this);
        pushReportList(this);
      } catch (e) {
        notifyDeleteFailed(this);
      } finally {
        this.$nextTick(() => {
          this.$vs.loading.close();
        });
      }
    },
    // ダウンロードボタン押下時
    onReportDownload() {
      this.isReportDownloadDialogActive = true;
    },
    onReportDownloadDialogClose() {
      this.isReportDownloadDialogActive = false;
    },
  },
};
</script>
